/**
 * Paths for autocomplete symbols.
 * - proxy: under our Next.js API → /api-next/autocomplete (rewrites to /api/autocomplete)
 * - upstream: external data API (server-side) → v2/autocomplete
 */
export const autocompleteSymbolsRoutes = {
  symbols: { proxy: 'autocomplete', upstream: 'v2/autocomplete' },
} as const;
